<template>
  <v-container fluid>
    <notification-e-letter-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      NotificationELetterContainerView: () => import('@/components/hris/employee/e-letter/ELetterReport'),
    },
    metaInfo () {
      return {
        title: 'Notification E-Letter',
      }
    },
  }
</script>
